export default __webpack_public_path__ + "static/shopify_banner-c73fd34fa01c2d97a17bfd5269f84cad.jpg";